import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '@/lib/i18n/useLocale';
import { PrimaryButton } from '@/components/buttons/PrimaryButton';
import Subscriber from './mainSection/svg/Subscriber';
import bgImage from '@/assets/imgs/signupcardbg.png';

// const cardStyle = {
//     backgroundColor: 'rgba(171, 214, 255, 0.25)',
//     border: '1px solid #E8EFF6',
//     boxShadow: '0 8px 28px 0 rgba(20, 20, 43, 0.1)',
// } as const;

export function CrmSignupCard() {
    const { t } = useTranslation();
    const localizedPath = useLocalizedPath();

    return (
        <div
            className="
  my-7 rounded-2xl py-8 md:py-10 px-8 md:px-14
  dark:!bg-[linear-gradient(90deg,rgba(67,125,179,0.45)_0%,rgba(0,57,110,0.16)_50%,rgba(67,125,179,0.45)_100%)]
"
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}

            // className="my-7 rounded-2xl p-8 md:p-10"
            // style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
            <div className="flex justify-between items-center">
                <div className="w-full">
                    <h3 className=" sm:text-[28px] text-[22px] font-bold text-primary-text">
                        {t('hrMangementPage.signupCardTitle')}
                    </h3>
                    <p className="text-primary-desc font-medium md:my-6 my-4 sm:text-[17px] text-[15px]">
                        {t('crmPage.signupCardDesc')}
                    </p>
                    <Link to={localizedPath('/sign-up?product=crm')}>
                        <PrimaryButton className="bg-primary-button text-[#ffff] hover:bg-[#1e63a3] tracking-normal font-cairo px-[45px] py-4 md:px-[65px] lg:py-[16px] md:py-[12px] lg:px-[85px] text-sm md:text-base font-bold rounded-lg leading-[125%]">
                            {t('hrMangementPage.signupCardButton')}
                        </PrimaryButton>
                    </Link>
                </div>

                <div className="hidden md:block motion-safe:animate-float">
                    <Subscriber />
                </div>
            </div>
        </div>
    );
}
